<template>
    <!-- 搜索栏 -->
    <el-form :inline="true">
        <el-form-item label="用户组名称：">
            <el-input v-model="searchForm.name" placeholder="请输入名称" clearable @keyup.enter="search"></el-input>
        </el-form-item>
        <el-form-item label="创建时间：">
            <el-date-picker
                v-model="pickerValue"
                value-format="YYYY-MM-DD"
                type="daterange"
                range-separator="-"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
            />
        </el-form-item>
        <el-form-item>
            <el-button type="primary" @click="search">搜索</el-button>
            <el-button type="primary" @click="getList">刷新</el-button>
            <el-button type="primary" @click="showAdd()">新增用户组</el-button>
        </el-form-item>
    </el-form>

    <el-table class="table_wrapper" :data="tableData" border :header-cell-style="{'text-align':'center','background':'#f5f7fa','color':'#333'}" :cell-style="{'text-align':'center'}">
        <el-table-column label="用户组名称" min-width="160" show-overflow-tooltip>
            <template #default="scope">
              <div>
                <span>{{ scope.row.name }}</span>
              </div>
            </template>
        </el-table-column>
        <el-table-column label="用户组编码" min-width="140" show-overflow-tooltip>
            <template #default="scope">
              <div>
                <span>{{ scope.row.code }}</span>
              </div>
            </template>
        </el-table-column>
        <el-table-column label="用户数量" min-width="100">
            <template #default="scope">
              <div>
                <span>{{ scope.row.userCount }}</span>
              </div>
            </template>
        </el-table-column>
        <el-table-column label="创建人" min-width="120">
            <template #default="scope">
              <div>
                <span>{{ scope.row.createdName }}</span>
              </div>
            </template>
        </el-table-column>
        <el-table-column label="创建时间" min-width="170">
            <template #default="scope">
              <div>
                <span>{{ scope.row.createTime }}</span>
              </div>
            </template>
        </el-table-column>
        <el-table-column label="更新时间" min-width="170">
            <template #default="scope">
              <div>
                <span>{{ scope.row.updateTime }}</span>
              </div>
            </template>
        </el-table-column>
        <el-table-column label="操作" width="180" fixed="right">
            <template #default="scope">
              <el-button link type="primary" size="small" @click="viewMembers(scope.row)">查看成员</el-button>
              <el-button link type="primary" size="small" @click="handleEdit(scope.row)">编辑</el-button>
              <el-button link type="primary" size="small" @click="handleDelete(scope.row)">删除</el-button>
            </template>
        </el-table-column>
    </el-table>

    <!-- 分页 -->
    <Pagination
        v-model:current-page="currentPage"
        v-model:page-size="pageSize"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
    />

    <!-- 对话框--新增/编辑用户组 -->
    <el-dialog v-model="dialogFormVisible" :title="is_update ? '编辑用户组' : '新增用户组'" width="560px" :close-on-click-modal="false">
        <el-form ref="addFormRef" :model="addInfo" :rules="addRules" label-position="right" label-width="100px">
            <el-form-item v-if="is_update" label="用户组编码">
                <el-input v-model="addInfo.code" disabled />
            </el-form-item>
            <el-form-item label="用户组名称" prop="name">
                <el-input v-model="addInfo.name" maxlength="20" placeholder="请输入用户组名称（不超过20字符，全局唯一）" />
            </el-form-item>
            <el-form-item label="备注">
                <el-input
                    v-model="addInfo.remark"
                    type="textarea"
                    :rows="4"
                    maxlength="100"
                    show-word-limit
                    placeholder="请输入备注（不超过100字符）"
                />
            </el-form-item>
        </el-form>
        <div class="dialog_tip">用户组编码由系统自动生成，创建后不可修改；成员可在保存后通过“查看成员”添加。</div>
        <template #footer>
            <div class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取消</el-button>
                <el-button type="primary" @click="save()">保存</el-button>
            </div>
        </template>
    </el-dialog>

    <!-- 对话框--查看成员 -->
    <el-dialog v-model="memberDialogVisible" title="查看成员" width="860px" align-center :close-on-click-modal="false">
        <div class="member_search">
            <span class="member_search_label">搜索账号：</span>
            <el-input
                v-model="memberSearchKey"
                style="width: 300px;"
                maxlength="11"
                placeholder="请输入个人账号(即完整手机号)"
                clearable
                @keyup.enter="searchMember"
            ></el-input>
            <el-button type="primary" style="margin-left: 8px;" @click="searchMember">
                <el-icon><Search /></el-icon>
            </el-button>
        </div>

        <!-- 用户组成员 -->
        <div class="member_box">
            <template v-if="memberListAll.length > 0">
                <span v-for="item in memberListAll" :key="item.id" class="member_item">
                    <span class="member_phone">{{ item.phone }}</span>
                    <span v-if="item.isPending" class="member_pending">待保存</span>
                    <el-icon class="member_remove" :title="item.isPending ? '取消添加' : '移除'" @click="removeMember(item)"><Close /></el-icon>
                </span>
            </template>
            <div v-else class="member_empty">暂无成员</div>
        </div>

        <template #footer>
            <div class="dialog-footer">
                <el-button @click="memberDialogVisible = false">返回</el-button>
                <el-button type="primary" @click="saveMembers()">保存</el-button>
            </div>
        </template>
    </el-dialog>
</template>

<script>
import { ElMessage } from 'element-plus';
import { required, isMobileValue } from '@/utils/validators';

export default {
    name: 'UserGroupManage',
    data() {
        return {
            searchForm: {
                name: '', //用户组名称
            },
            pickerValue: '', //创建时间范围
            tableData: [], //列表
            total: 0, //总条数
            currentPage: 1, //当前页
            pageSize: 10, //每页显示条数

            dialogFormVisible: false, //新增/编辑弹窗
            is_update: 0, //编辑/新增
            addFormRef: null,
            addRules: {
                name: [
                    required('请输入用户组名称'),
                    { max: 20, message: '用户组名称不超过20个字符', trigger: 'blur' },
                ],
            },
            addInfo: {
                id: '',
                name: '',
                code: '',
                remark: '',
            },

            memberDialogVisible: false, //查看成员弹窗
            currentGroup: null, //当前用户组
            memberSearchKey: '', //搜索账号
            memberListAll: [], //全部成员（含待保存项）
            removeIds: [], //待移除的成员id
            pendingList: [], //待添加的成员（保存后生效）
        }
    },
    mounted() {
        this.getList(); //获取列表
    },
    methods: {
        //搜索
        search(){
            this.currentPage = 1;
            this.getList();
        },
        handleSizeChange(val) { //每页显示条数
            this.pageSize = val;
            this.currentPage = 1;
            this.getList();
        },
        handleCurrentChange(val) { //当前页
            this.currentPage = val;
            this.getList();
        },
        getList() { //获取用户组列表
            let that = this;
            let param = {};
            param.page = that.currentPage;
            param.pageSize = that.pageSize;
            param.name = that.searchForm.name;
            if (that.pickerValue && that.pickerValue[0] && that.pickerValue[1]) {
                param.startTime = that.pickerValue[0]; //创建时间区间-开始(yyyy-MM-dd,含当天)
                param.endTime = that.pickerValue[1]; //创建时间区间-结束(yyyy-MM-dd,含当天)
            }
            that.$axios.post(that.$store.state.platformApi + "charge/userGroup/page", JSON.stringify(param)).then(result => {
                if (result.code == 200) {
                    that.tableData = result.data.records;
                    that.total = result.data.total;
                }
            })
        },
        showAdd() { //打开新增弹窗
            this.is_update = 0;
            this.addInfo = {
                id: '',
                name: '',
                code: '',
                remark: '',
            };
            this.dialogFormVisible = true;
            this.$nextTick(() => {
                if (this.$refs.addFormRef) {
                    this.$refs.addFormRef.clearValidate();
                }
            });
        },
        handleEdit(row) { //打开编辑弹窗
            let that = this;
            that.is_update = 1;
            that.addInfo = {
                id: row.id,
                name: row.name,
                code: row.code,
                remark: row.remark ? row.remark : '',
            };
            that.dialogFormVisible = true;
        },
        save() { //保存新增/编辑
            let that = this;
            this.$refs.addFormRef.validate((valid) => {
                if (!valid) return;
                var url = that.is_update == 1 ? that.$store.state.platformApi + "charge/userGroup/update" : that.$store.state.platformApi + "charge/userGroup/add";
                that.$axios.post(url, JSON.stringify(that.addInfo)).then(result => {
                    if (result.code == 200) {
                        that.dialogFormVisible = false;
                        that.getList();
                        ElMessage({
                            message: '保存成功',
                            type: 'success',
                        })
                    }
                })
            });
        },
        handleDelete(row) { //删除用户组
            let that = this;
            this.$confirm('确定删除该用户组吗？', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
            })
            .then(_ => {
                that.$axios.post(that.$store.state.platformApi + "charge/userGroup/del/" + row.id).then(result => {
                    if (result.code == 200) {
                        that.getList();
                        ElMessage({
                            message: '已删除用户组',
                            type: 'success',
                        })
                    }
                })
            })
        },
        viewMembers(row) { //打开查看成员弹窗
            let that = this;
            that.currentGroup = row;
            that.memberSearchKey = '';
            that.memberListAll = [];
            that.pendingList = [];
            that.removeIds = [];
            that.memberDialogVisible = true;
            that.getMemberList();
        },
        getMemberList() { //获取用户组成员
            let that = this;
            that.$axios.post(that.$store.state.platformApi + "charge/userGroup/member/list/" + that.currentGroup.id).then(result => {
                if (result.code == 200) {
                    //接口返回{userId, phoneNumber}，转换为弹窗使用的{id, phone, isPending}
                    that.memberListAll = (result.data || []).map(m => ({ id: m.userId, phone: m.phoneNumber, isPending: false }));
                }
            })
        },
        searchMember() { //搜索账号（按完整手机号精确匹配），结果加入下方成员区域
            let that = this;
            let key = (that.memberSearchKey || '').trim();
            if (!isMobileValue(key)) {
                ElMessage({
                    message: '请输入正确的11位手机号',
                    type: 'warning',
                })
                return;
            }
            that.$axios.post(that.$store.state.platformApi + "charge/userGroup/users/" + key).then(result => {
                if (result.code == 200) {
                    let users = result.data || [];
                    if (!Array.isArray(users)) {
                        users = [users]; //接口返回单个对象时转为数组
                    }
                    that.addSearchResult(users);
                    that.memberSearchKey = '';
                }
            })
        },
        addSearchResult(users) { //将搜索到的用户加入成员区域（保存后生效）
            let that = this;
            if (users.length == 0) {
                ElMessage({
                    message: '未搜索到该用户',
                    type: 'warning',
                })
                return;
            }
            let existsPhones = that.memberListAll.map(m => m.phone); //已在组内及待保存的账号
            let added = 0;
            users.forEach(user => {
                if (user.phoneNumber && existsPhones.indexOf(user.phoneNumber) == -1) {
                    let pending = { id: 'new-' + (user.userId || user.userid || user.phoneNumber), phone: user.phoneNumber, isPending: true };
                    that.pendingList.push(pending);
                    that.memberListAll.push(pending);
                    existsPhones.push(user.phoneNumber);
                    added++;
                }
            });
            if (added == 0) {
                ElMessage({
                    message: '该用户已在该用户组中',
                    type: 'warning',
                })
            }
        },
        removeMember(item) { //移除成员：待保存项直接取消，已有成员保存后生效
            let that = this;
            that.memberListAll = that.memberListAll.filter(m => m.id != item.id);
            if (item.isPending) {
                that.pendingList = that.pendingList.filter(p => p.id != item.id);
            } else {
                that.removeIds.push(item.id);
            }
        },
        saveMembers() { //保存成员变更（移除+新增）
            let that = this;
            if (that.removeIds.length == 0 && that.pendingList.length == 0) {
                ElMessage({
                    message: '暂无变更内容',
                    type: 'warning',
                })
                return;
            }
            let requests = [];
            if (that.removeIds.length > 0) { //移除成员
                requests.push(that.$axios.post(that.$store.state.platformApi + "charge/userGroup/member/remove", JSON.stringify({
                    groupId: that.currentGroup.id,
                    userIds: that.removeIds,
                })));
            }
            if (that.pendingList.length > 0) { //添加成员
                requests.push(that.$axios.post(that.$store.state.platformApi + "charge/userGroup/member/add", JSON.stringify({
                    groupId: that.currentGroup.id,
                    phones: that.pendingList.map(p => p.phone),
                })));
            }
            Promise.all(requests).then(results => {
                if (results.every(r => r.code == 200)) {
                    let hadRemove = that.removeIds.length > 0;
                    that.removeIds = [];
                    that.pendingList = [];
                    if (hadRemove) {
                        //移除成员保存成功后关闭弹窗
                        that.memberDialogVisible = false;
                    } else {
                        that.getMemberList();
                    }
                    that.getList(); //刷新列表中的用户数量
                    ElMessage({
                        message: '保存成功',
                        type: 'success',
                    })
                }
            })
        },
    }
}
</script>

<style lang="scss" scoped>
.dialog_tip {
    color: #909399;
    font-size: 12px;
    line-height: 1.8;
    padding: 0 12px;
    margin-top: 4px;
}
.member_search {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
    .member_search_label {
        font-size: 14px;
        color: #606266;
        white-space: nowrap;
    }
}
.member_box {
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    padding: 12px;
    min-height: 120px;
    max-height: 200px;
    overflow-y: auto;
    margin-bottom: 12px;
    .member_item {
        display: inline-flex;
        align-items: center;
        margin: 8px 24px 8px 0;
        .member_phone {
            color: #409eff;
            text-decoration: underline;
            font-size: 14px;
            margin-right: 4px;
        }
        .member_pending {
            color: #409eff;
            font-size: 12px;
            border: 1px solid #409eff;
            border-radius: 3px;
            padding: 0 4px;
            margin-right: 4px;
            line-height: 18px;
        }
        .member_remove {
            color: #f56c6c;
            font-size: 14px;
            cursor: pointer;
        }
    }
    .member_empty {
        text-align: center;
        color: #909399;
        font-size: 13px;
        line-height: 90px;
    }
}
</style>
